import { ArrayFieldTemplateProps } from '@rjsf/utils';
import * as React from 'react';

/**
 * Simplified array field template.
 *
 * Features:
 * - No add/remove/reorder buttons
 * - No array title, description, or validation messages
 * - Creates read-only-like array display
 *
 * @param props - Standard RJSF array field template props
 * @returns Minimal array display with just the item content
 */
export const ReadOnlyArrayFieldTemplate = (props: ArrayFieldTemplateProps) => {
  return (
    <div>
      {props.items.map((element) => (
        <div key={element.key}>{element.children}</div>
      ))}
    </div>
  );
};
